/** String enum: member names are PascalCase; values are kebab-case `fst-*` suffixes in `styles.scss`. */
export enum TypographyKey {
  BodyXlSemiBold = 'body-xl-semi-bold',
  BodyXlReg = 'body-xl-reg',
  BodyLSemiBold = 'body-l-semi-bold',
  BodyLReg = 'body-l-reg',
  BodyMSemiBold = 'body-m-semi-bold',
  BodyMReg = 'body-m-reg',
  BodyMLight = 'body-m-light',
  BodyXsSemiBold = 'body-xs-semi-bold',
  BodyXsReg = 'body-xs-reg',
  BodyXsLight = 'body-xs-light',
  HeaderXlSemiBold = 'header-xl-semi-bold',
  HeaderLSemiBold = 'header-l-semi-bold',
  HeaderMSemiBold = 'header-m-semi-bold',
  HeaderSSemiBold = 'header-s-semi-bold',
  HeaderSReg = 'header-s-reg'
}

export type TypographyElement = 'div' | 'span' | 'p'

/** String enum: values are kebab-case tokens used as `text-${value}` in `Typography.vue`. */
export enum TypographyColor {
  Primary500 = 'primary-500',
  Primary700 = 'primary-700',
  Primary900 = 'primary-900',
  Grey600 = 'grey-600',
  Grey700 = 'grey-700',
  Error500 = 'error-500',
  Success500 = 'success-500',
  Warning500 = 'warning-500',
  Secondary500 = 'secondary-500',
  Secondary50 = 'secondary-50'
}

const TYPOGRAPHY_LINK_MODIFIER_CLASS = 'fst-link-variant'

export function getTypographyClass(key: TypographyKey, isLink?: boolean): string {
  const baseClass = `fst-${key}`

  if (!isLink) return baseClass
  return `${baseClass} ${TYPOGRAPHY_LINK_MODIFIER_CLASS}`
}
